var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-journals-collection-card"},[_c('div',{staticClass:"empty-journals-collection-card__wrapper"},[_c('EmptyDefaultText',{attrs:{"width":"65%","mode":"white"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }